<div class="modal-overlay">
  <div class="modal-container">
    
    <div class="modal-header">
      <div class="modal-header-content">
        <mat-icon class="warning-icon">warning</mat-icon>
        <h3>{{ 'COMMON.WARNING' | translate }}</h3>
      </div>
      <button type="button" class="close-button" (click)="dismissError()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="modal-body">
      <p>{{ 'ERRORS.SERVER_MESSAGE' | translate }}</p>
      <p class="warning-text">{{ errorMessage | translate }}</p>
    </div>

    <div class="modal-footer">
      <button type="button" class="cancel-button" (click)="dismissError()">
        {{ 'COMMON.CLOSE' | translate }}
      </button>
    </div>

  </div>
</div>